import { AudienceCount } from '../../../types';
import { useTranslation } from '../../../hooks';
import { AudienceCountsTable } from '../audienceCountsTable';
import { PercentageInsightPanel } from './PercentageInsightPanel';
import { useBehaviorQueryContext } from '../../../contexts/behaviorInsights/behaviorQuery';

export const UnsubscribeRatePanel = () => {
  const { totalSent, totalUnsubscribes, unsubscribeRate } = useBehaviorQueryContext();
  const sent = totalSent?.value || 0;
  const unsubscribed = totalUnsubscribes?.value || 0;
  const { t } = useTranslation();
  const details: AudienceCount[] = [
    {
      name: t('insights.totalUnsubscribed'),
      count: unsubscribed,
    },
    {
      name: t('insights.totalSent'),
      count: sent,
    },
  ];

  const hasUnsubscribedMetrics = Boolean(sent + unsubscribed);

  return (
    <PercentageInsightPanel
      title={t('insights.unsubscribeRate')}
      percentage={unsubscribeRate?.value}
      isEmpty={!hasUnsubscribedMetrics}
    >
      {hasUnsubscribedMetrics && <AudienceCountsTable values={details} />}
    </PercentageInsightPanel>
  );
};
